import { AI_TOOLKIT_CATEGORIES, type AiToolkitCategory } from './types';

/** Where a toast for a background task sends the user to check on it. */
export const CATEGORY_TOAST_HREF: Record<AiToolkitCategory, string> = {
    [AI_TOOLKIT_CATEGORIES.VIDEO_GENERATION]: '/ai/video-generation',
    [AI_TOOLKIT_CATEGORIES.IMAGE_GENERATION]: '/ai/image-generation',
    [AI_TOOLKIT_CATEGORIES.VOICEOVER]: '/ai/voiceover',
    [AI_TOOLKIT_CATEGORIES.VIDEO_EDIT]: '/ai/video-edit',
};
